<div class="suggestions">
  <ul>
    <li class="suggestions__linkLabel" *ngFor="let link of candidates; let index = index">
      <vc-ref
        [resource]="link.path"
        (click)="clickSeoLink.emit({position: index, label: link.label, path: link.path})"
        >{{ link.label }}</vc-ref
      >
    </li>
  </ul>
</div>
